export const shouldDisableDispositiveActions = (typeUser, roles) => {
    if (!typeUser)
        return true

    if (typeUser.toLowerCase() === "operator")
        return false

    if (!roles)
        return true

    return !(typeUser.toLowerCase() === "customer" && roles.toLowerCase().includes("c"))
}

export const shouldDisableGesticiTags = (typeUser, roles) => {
    if (!typeUser)
        return true

    if (typeUser.toLowerCase() === "operator")
        return false

    if (!roles)
        return true

    return !(typeUser.toLowerCase() === "customer" && roles.toLowerCase().includes("a"))
}
